import React, { useState } from 'react';
import { Select as MuiSelect } from '@mui/material';
import { withStyles } from '@mui/styles';
import { ExpandMore } from '@mui/icons-material';
import { DROPDOWN_BOX_SHADOW } from '../../../const';

const styles = {
  select: {
    '&:before': {
      borderBottom: '1px solid rgb(224, 224, 224)',
    },
    '& .MuiSelect-selectMenu': {
      padding: '6px 24px 7px 7px',
    },
    '& .MuiSelect-select': {
      padding: '3px 24px 3px 10px',
    },
  },
};

const DEFAULT_SELECT_WIDTH_MIN = 130;
const DEFAULT_SELECT_WIDTH_MAX = 300;
const DEFAULT_SELECT_HEIGHT_MAX = 400;

export const Select = withStyles(styles)((props) => {
  const [selectMinWidth, setSelectMinWidth] = useState(DEFAULT_SELECT_WIDTH_MIN);

  const menuClassName = props.menuClassName || 'select-menu';

  const defaultSelectMenuProps = {
    variant: 'menu',
    className: menuClassName,
    placement: 'bottom-start',
    MenuListProps: {
      style: {
        padding: 0,
      },
    },
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left',
    },
    slotProps: {
      paper: {
        style: {
          minWidth: selectMinWidth,
          maxWidth: DEFAULT_SELECT_WIDTH_MAX,
          maxHeight: props.maxListHeight || DEFAULT_SELECT_HEIGHT_MAX,
          padding: 0,
          boxShadow: DROPDOWN_BOX_SHADOW,
        },
      },
    },
    ...(props.MenuProps || {}),
  };

  const handleOpen = (event) => {
    const select = event.target.closest('.MuiSelect-select') || event.target;

    setSelectMinWidth(Math.max(select.clientWidth, DEFAULT_SELECT_WIDTH_MIN));
    if (props.onOpen) {
      props.onOpen(event);
    }
  };

  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    }
  };

  return (
    <MuiSelect
      open={props.open}
      defaultValue={props.defaultValue}
      name={props.name}
      displayEmpty={props.displayEmpty}
      className={`${props.classes.select} ${props.className}`}
      value={props.value}
      multiple={props.multiple}
      renderValue={props.renderValue}
      onChange={props.onChange}
      fullWidth={props.fullWidth}
      autoWidth={props.autoWidth}
      placeholder={props.placeholder}
      style={props.style}
      disabled={props.disabled}
      error={props.error}
      onOpen={props.onOpen || handleOpen}
      onClose={handleClose}
      MenuProps={props.MenuProps || defaultSelectMenuProps}
      IconComponent={ExpandMore}
    >
      {props.children}
    </MuiSelect>
  );
});

export default Select;
